<template>
    <div class="mb-3">
        <div class="row">
            <div class="col-6 card p-3 mx-3">
                <div class="row">
                    <div class="col">
                        <app-input id="name" v-model="form.name" name="name" rules="required">
                            <template #label>
                                {{ $t('Name') }}*
                            </template>
                        </app-input>
                        <app-input id="drivers_license" v-model="form.drivers_license" name="drivers_license">
                            <template #label>
                                {{ $t('Drivers license no') }}
                            </template>
                        </app-input>
                    </div>
                    <div class="col">
                        <app-input id="idcode" v-model="form.idcode" name="idcode">
                            <template #label>
                                {{ $t('Id code') }}
                            </template>
                        </app-input>
                        <app-input id="id_card" v-model="form.id_card" name="id_card">
                            <template #label>
                                {{ $t('Id card no') }}
                            </template>
                        </app-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-input id="address" v-model="form.address" name="address">
                            <template #label>
                                {{ $t('Address') }}
                            </template>
                        </app-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-input id="phone" v-model="form.phone" name="phone" rules="required">
                            <template #label>
                                {{ $t('Phone') }}*
                            </template>
                        </app-input>
                    </div>
                    <div class="col">
                        <app-input id="email" v-model="form.email" name="email" rules="required">
                            <template #label>
                                {{ $t('Email') }}*
                            </template>
                        </app-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-input id="cc_no" v-model="form.cc_no" name="cc_no">
                            <template #label>
                                {{ $t('Creditcard no') }}
                            </template>
                        </app-input>
                    </div>
                    <div class="col">
                        <app-input id="cc_validity" v-model="form.cc_validity" name="cc_validity">
                            <template #label>
                                {{ $t('Creditcard expiry') }}
                            </template>
                        </app-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-input id="discount_percent" v-model="form.discount_percent" type="number" name="discount_percent">
                            <template #label>
                                {{ $t('Discount') }} %
                            </template>
                        </app-input>
                    </div>
                    <div class="col">
                        <app-textarea id="comments" v-model="form.comments" name="comments">
                            <template #label>
                                {{ $t('Comments') }}
                            </template>
                        </app-textarea>
                    </div>
                </div>
                <h4 class="mt-0">{{ $t('Company') }}</h4>
                <div class="row">
                    <div class="col">
                        <app-input id="company_name" v-model="form.company_name" name="company_name">
                            <template #label>
                                {{ $t('Company name') }}
                            </template>
                        </app-input>
                    </div>
                    <div class="col">
                        <app-input id="company_reg" v-model="form.company_reg" name="company_reg">
                            <template #label>
                                {{ $t('Reg no') }}
                            </template>
                        </app-input>
                    </div>
                    <div class="col">
                        <app-input id="company_email" v-model="form.company_email" name="company_email">
                            <template #label>
                                {{ $t('Email') }}
                            </template>
                        </app-input>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col">
                        <app-checkbox id="newsletter" v-model="form.newsletter" name="newsletter">
                            {{ $t('Newsletter') }}
                        </app-checkbox>
                        <app-checkbox id="bond" v-model="form.bond" name="bond">
                            {{ $t('Bond required') }}
                        </app-checkbox>
                        <app-checkbox id="tos" v-model="form.tos" name="tos">
                            {{ $t('Accepted terms') }}
                        </app-checkbox>
                    </div>
                </div>
                <div class="form-group">
                    <app-button :loading="loading" small>
                        {{ $t('Save') }}
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientForm',
    props: {
        form: Object,
        loading: Boolean
    },
    methods: {
        store() {
            this.$emit('store');
        }
    }
};
</script>
